import { CartAddEvent } from '@theme/events';
import { sectionRenderer } from '@theme/section-renderer';

/**
 * Collection Products JavaScript
 * Handles add-to-cart functionality for collection page product cards
 */

document.addEventListener('DOMContentLoaded', function() {
  // Add a small delay to ensure all dynamic content is loaded
  setTimeout(() => {
    initCollectionProducts();
  }, 100);
});

function initCollectionProducts() {
  const addToCartForms = document.querySelectorAll('.featured-products__add-to-cart-form');
  
  if (addToCartForms.length > 0 && addToCartForms[0].hasAttribute('data-variant-id')) {
    return;
  }
  
  if (addToCartForms.length === 0) {
    const altForms = document.querySelectorAll('form[action*="cart/add"]');
    
    altForms.forEach((form, index) => {
      form.addEventListener('submit', handleAddToCart);
    });
  } else {
    addToCartForms.forEach((form, index) => {
      form.addEventListener('submit', handleAddToCart);
    });
  }
  
  // Also listen for dynamically added forms
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            const newForms = node.querySelectorAll ? node.querySelectorAll('.featured-products__add-to-cart-form') : [];
            newForms.forEach(form => {
              form.addEventListener('submit', handleAddToCart);
            });
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

async function handleAddToCart(event) {
  event.preventDefault();
  event.stopPropagation();
  
  const form = event.target;
  const button = form.querySelector('.featured-products__add-to-cart-btn');
  const originalContent = button.innerHTML;
  
  // Update button state
  setButtonState(button, 'Adding...', true);
  
  try {
    const formData = new FormData(form);
    
    const result = await addToCart(formData);
    
    // Dispatch cart add event to trigger cart drawer opening and refresh
    dispatchCartEvent(result);
    
    // Manually open the cart drawer
    openCartDrawer();
    
    // Update button text temporarily
    setButtonState(button, 'Added!', true);
    setTimeout(() => {
      setButtonState(button, originalContent, false);
    }, 2000);
    
  } catch (error) {
    console.error('Collection Products: Error adding to cart:', error);
    setButtonState(button, 'Error', true);
    setTimeout(() => {
      setButtonState(button, originalContent, false);
    }, 2000);
  }
  
  return false;
}

async function addToCart(formData) {
  // Use Theme.routes.cart_add_url which already includes .js, or fallback to window.routes + .js
  const cartAddUrl = Theme?.routes?.cart_add_url || (window.routes?.cart_add_url + '.js') || '/cart/add.js';
  
  const response = await fetch(cartAddUrl, {
    method: 'POST',
    headers: {
      'Accept': 'application/javascript',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams(formData)
  });
  
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  
  const contentType = response.headers.get('content-type');
  if (contentType && (contentType.includes('application/json') || contentType.includes('text/javascript'))) {
    const result = await response.json();
    return result;
  } else {
    const text = await response.text();
    throw new Error('Server returned non-JSON response');
  }
}

function dispatchCartEvent(cartData) {
  
  const event = new CartAddEvent(cartData, 'collection-products', {
    source: 'collection-products',
    itemCount: cartData.quantity || 1,
    productId: cartData.product_id
  });
  document.dispatchEvent(event);
}

function openCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer-component');
  if (cartDrawer && typeof cartDrawer.open === 'function') {
    cartDrawer.open();
  } else if (cartDrawer && typeof cartDrawer.showDialog === 'function') {
    cartDrawer.showDialog();
  } else {
  }

  // Proactively refresh the cart drawer contents using Section Rendering API
  try {
    const cartItemsComponent = cartDrawer?.querySelector('cart-items-component');
    const sectionId = cartItemsComponent?.dataset?.sectionId;
    if (sectionId) {
      // Small delay to ensure drawer DOM is ready
      setTimeout(() => {
        sectionRenderer.renderSection(sectionId, { cache: false });
      }, 100);
    }
  } catch (e) {
    console.error('Collection Products: Failed to refresh cart drawer', e);
  }
}

function setButtonState(button, text, disabled) {
  if (disabled) {
    button.disabled = true;
    button.innerHTML = text;
    button.style.opacity = '0.7';
  } else {
    button.disabled = false;
    button.innerHTML = text;
    button.style.opacity = '1';
  }
}
